import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Plus, Trash2, X, ShieldCheck, UserCog } from "lucide-react";

const errText = (d, f) => (typeof d === "string" ? d : f);

export default function AdminTeam() {
  const { user } = useAuth();
  const [team, setTeam] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "staff" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const load = () => api.get("/admin/staff").then((r) => setTeam(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/staff", form);
      toast.success("Team member added");
      setForm({ name: "", email: "", password: "", role: "staff" });
      setShowForm(false); load();
    } catch (err) {
      toast.error(errText(err.response?.data?.detail, "Error"));
    }
  };
  const del = async (id) => {
    if (!window.confirm("Remove this team member?")) return;
    try { await api.delete(`/admin/staff/${id}`); toast.success("Removed"); load(); }
    catch (err) { toast.error(errText(err.response?.data?.detail, "Error")); }
  };

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <div>
          <h2 className="font-serif text-3xl md:text-4xl">Team</h2>
          <p className="text-white/40 text-sm mt-1">Admins and employees with panel access.</p>
        </div>
        <button data-testid="new-staff-btn" onClick={() => setShowForm(true)} className="inline-flex items-center gap-2 bg-gold text-black text-xs uppercase tracking-widest px-5 py-2.5 hover:bg-white transition-colors"><Plus size={15} /> Add Member</button>
      </div>

      <div className="border border-white/10 divide-y divide-white/10">
        {team.map((m) => (
          <div key={m.id} data-testid={`staff-row-${m.id}`} className="flex items-center justify-between gap-4 p-5">
            <div className="flex items-center gap-4">
              {m.role === "admin" ? <ShieldCheck size={20} className="text-gold" /> : <UserCog size={20} className="text-white/50" />}
              <div>
                <p className="font-serif text-xl">{m.name} {m.id === user?.id && <span className="text-xs text-gold">(you)</span>}</p>
                <p className="text-white/40 text-sm">{m.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <span className="text-[10px] uppercase tracking-widest border border-white/15 px-2 py-1 text-white/60">{m.role}</span>
              {m.id !== user?.id && (
                <button onClick={() => del(m.id)} data-testid={`delete-staff-${m.id}`} className="text-white/50 hover:text-red-400"><Trash2 size={16} /></button>
              )}
            </div>
          </div>
        ))}
      </div>

      {showForm && (
        <div className="fixed inset-0 z-[200] bg-black/80 backdrop-blur-sm flex items-center justify-center p-6" onClick={() => setShowForm(false)}>
          <div className="w-full max-w-md border border-white/10 bg-[#0a0a0a] p-8" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6"><h3 className="font-serif text-2xl">Add Team Member</h3><button onClick={() => setShowForm(false)} className="text-white/50 hover:text-white"><X size={20} /></button></div>
            <form onSubmit={save} className="space-y-5" data-testid="staff-form">
              <input required placeholder="Full name" value={form.name} onChange={set("name")} className="editorial-input" data-testid="staff-name" />
              <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className="editorial-input" data-testid="staff-email" />
              <input required type="text" placeholder="Password" value={form.password} onChange={set("password")} className="editorial-input" data-testid="staff-password" />
              <select value={form.role} onChange={set("role")} className="editorial-input [&>option]:bg-black" data-testid="staff-role">
                <option value="staff">Staff (employee)</option>
                <option value="admin">Administrator</option>
              </select>
              <button className="w-full bg-gold text-black text-xs uppercase tracking-widest py-3 hover:bg-white transition-colors" data-testid="staff-save">Add member</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
